import type {Icon} from '@primer/octicons-react'

const SIZE_MAP = {
  small: 16,
  medium: 32,
  large: 64,
} as const

export const ViewFilesIcon = ({'aria-label': ariaLabel}: {'aria-label'?: string}) => (
  <svg aria-label={ariaLabel} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.75 10C2.16421 10 2.5 10.3358 2.5 10.75V13.25C2.5 13.3881 2.61193 13.5 2.75 13.5H5.25C5.66421 13.5 6 13.8358 6 14.25C6 14.6642 5.66421 15 5.25 15H2.75C1.7835 15 1 14.2165 1 13.25V10.75C1 10.3358 1.33579 10 1.75 10ZM14.25 10C14.6642 10 15 10.3358 15 10.75V13.25C15 14.2165 14.2165 15 13.25 15H10.75C10.3358 15 10 14.6642 10 14.25C10 13.8358 10.3358 13.5 10.75 13.5H13.25C13.3881 13.5 13.5 13.3881 13.5 13.25V10.75C13.5 10.3358 13.8358 10 14.25 10ZM8.25 10C8.66421 10 9 10.3358 9 10.75C9 11.1642 8.66421 11.5 8.25 11.5H5.25C4.83579 11.5 4.5 11.1642 4.5 10.75C4.5 10.3358 4.83579 10 5.25 10H8.25ZM11.25 7.5C11.6642 7.5 12 7.83579 12 8.25C12 8.66421 11.6642 9 11.25 9H5.25C4.83579 9 4.5 8.66421 4.5 8.25C4.5 7.83579 4.83579 7.5 5.25 7.5H11.25ZM10.25 5C10.6642 5 11 5.33579 11 5.75C11 6.16421 10.6642 6.5 10.25 6.5H5.25C4.83579 6.5 4.5 6.16421 4.5 5.75C4.5 5.33579 4.83579 5 5.25 5H10.25ZM5.25 1C5.66421 1 6 1.33579 6 1.75C6 2.16421 5.66421 2.5 5.25 2.5H2.75C2.61193 2.5 2.5 2.61193 2.5 2.75V5.25C2.5 5.66421 2.16421 6 1.75 6C1.33579 6 1 5.66421 1 5.25V2.75C1 1.7835 1.7835 1 2.75 1H5.25ZM13.25 1C14.2165 1 15 1.7835 15 2.75V5.25C15 5.66421 14.6642 6 14.25 6C13.8358 6 13.5 5.66421 13.5 5.25V2.75C13.5 2.61193 13.3881 2.5 13.25 2.5H10.75C10.3358 2.5 10 2.16421 10 1.75C10 1.33579 10.3358 1 10.75 1H13.25Z"
      fill="currentColor"
    />
  </svg>
)

export const JetBrainsIcon: Icon = ({
  'aria-label': ariaLabel,
  className = '',
  size = 16,
  verticalAlign = 'text-bottom',
}) => {
  const resolvedSize = typeof size === 'number' ? size : SIZE_MAP[size]

  return (
    <svg
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
      className={className}
      height={resolvedSize}
      role={ariaLabel ? 'img' : undefined}
      style={{display: 'inline-block', verticalAlign}}
      viewBox="0 0 16 16"
      width={resolvedSize}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.56341 15.9977H8.6715V16c.89305 0 1.7338-.3499 2.3701-.9815l3.9767-3.9762c.6249-.6248.9817-1.4882.9817-2.36977V1.56319C16 .699801 15.2978 0 14.4366 0H7.32624c-.89079 0-1.73385.349902-2.36786.981541L.981678 4.95541C.356768 5.58023 0 6.44363 0 7.32519v7.10931c0 .8634.702174 1.5632 1.56341 1.5632M2.6419 4.34286l2.83913-2.83874c.4954-.49304 1.14985-.763421 1.84521-.763421h7.11036c.4545 0 .8226.370351.8226.822491v7.10934c0 .68617-.2772 1.35867-.7635 1.84497l-2.8386 2.8381V4.34286zm-.12761.12759v9.01525H11.527l-1.008 1.0079c-.4931.4908-1.14988.7634-1.84524.7634H1.56341c-.45448 0-.822605-.3703-.822605-.8225V7.32519c0-.68617.277235-1.3587.763525-1.84494zm5.02857 6.95815H3.65714v.9143h3.88572z"
        clipRule="evenodd"
      />
    </svg>
  )
}
